// import utils from '../../../common/utils'
// import api from '../../../common/api'

export default {
    methods: {
    /**
     * 弹层提交按钮
     * @param {String} name 校验类型
     */
        handleSubmit(name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    if (name === 'formValidate') {
                        if (this.isAddOrEdit === 'edit') {
                            this.roleUpdate()
                        } else {
                            this.addRoleData()
                        }
                    }
                    if (name === 'menuFormValidate') {
                        if (this.menuFormValidate.id) {
                            this.menuUpdate()
                        } else {
                            this.menuAdd()
                        }
                    }
                }
            })
        },
        /**
     * 弹层删除按钮
     */
        roleCancel() {
            this.roleModal = false
            this.handleReset('formValidate')
        },
        /**
     * 重置表单
     * @param {String} name form表单定位的名称
     */
        handleReset(name) {
            this.$refs[name].resetFields()
        }
    }
}
